import BaseAPI from './base'

const registrationAPI = {
  getClcGroupSelect (data) { return BaseAPI('get', `/Registration/SelectClcGroup`, data) },
  getList (payload) { return BaseAPI('post', `/Registration/QueryDataList`, payload) },

  modify (payload) { return BaseAPI('post', `/Registration/ModifyData`, payload) },
  delete (payload) { return BaseAPI('post', `/Registration/DeleteData`, payload) },

  analyze (payload) { return BaseAPI('post', `/Registration/analyzeData`, payload) },

  exportData (data) { return BaseAPI('get', `/Registration/ExportData`, data)},
  exportTable (data) { return BaseAPI('get', `/Registration/ExportTable`, data) },
}


export default {
  registrationAPI
}
